import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from './components/nuxt-error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_iview_fabcf5d2 from 'nuxt_plugin_iview_fabcf5d2' // Source: ../plugins/iview (mode: 'all')
import nuxt_plugin_element_f89b5a74 from 'nuxt_plugin_element_f89b5a74' // Source: ../plugins/element (mode: 'client')
import nuxt_plugin_vextable_3b0d4418 from 'nuxt_plugin_vextable_3b0d4418' // Source: ../plugins/vex-table (mode: 'client')
import nuxt_plugin_common_7195563e from 'nuxt_plugin_common_7195563e' // Source: ../plugins/common (mode: 'client')
import nuxt_plugin_request_281e2659 from 'nuxt_plugin_request_281e2659' // Source: ../plugins/request (mode: 'client')
import nuxt_plugin_route_338f5eda from 'nuxt_plugin_route_338f5eda' // Source: ../plugins/route (mode: 'client')
import nuxt_plugin_vueextend_2b93c540 from 'nuxt_plugin_vueextend_2b93c540' // Source: ../plugins/vue-extend.js (mode: 'client')
import nuxt_plugin_echarts_6c3fad43 from 'nuxt_plugin_echarts_6c3fad43' // Source: ../plugins/echarts (mode: 'all')
import nuxt_plugin_tim_6e03153e from 'nuxt_plugin_tim_6e03153e' // Source: ../plugins/tim (mode: 'client')
import nuxt_plugin_sliderVerify_311cc9a0 from 'nuxt_plugin_sliderVerify_311cc9a0' // Source: ../plugins/sliderVerify (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"百年育才","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":"{{escape description }}"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"stylesheet","href":"\u002F\u002Flive-cdn.baijiayun.com\u002Fwww-video-jssdk\u002F0.0.5\u002Fplayback\u002Fplayer.css"},{"rel":"stylesheet","href":"\u002F\u002Flive-cdn.baijiayun.com\u002Fwww-video-jssdk\u002Fdep\u002Fvideojs\u002F0.0.6\u002Fdist\u002Fvideojs.css"},{"rel":"stylesheet","href":"\u002Fueditor\u002Fthemes\u002Fdefault\u002Fcss\u002Fueditor.css"}],"script":[{"src":"https:\u002F\u002Fapps.bdimg.com\u002Flibs\u002Fjquery\u002F2.0.0\u002Fjquery.min.js"},{"src":"\u002F\u002Flive-cdn.baijiayun.com\u002Fwww-video-jssdk\u002F0.0.5\u002Fplayback\u002Fplayer.js"},{"src":"\u002F\u002Flive-cdn.baijiayun.com\u002Fwww-video-jssdk\u002Fdep\u002Fvideojs\u002F0.0.6\u002Fdist\u002Fvideojs.js"},{"src":"\u002F\u002Flive-cdn.baijiayun.com\u002Fwww-video-jssdk\u002F0.0.7\u002FbjcPlayer\u002Findex.js"},{"src":"\u002Fckeditor\u002Fckeditor.js","type":"text\u002Fjavascript","charset":"utf-8"},{"src":"\u002Fueditor\u002Fueditor.config.js","type":"text\u002Fjavascript","charset":"utf-8"},{"src":"\u002Fueditor\u002Fueditor.all.min.js","type":"text\u002Fjavascript","charset":"utf-8"},{"src":"\u002Fueditor\u002Fueditor.all.js","type":"text\u002Fjavascript","charset":"utf-8"},{"src":"\u002Fueditor\u002Fueditor.parse.min.js","type":"text\u002Fjavascript","charset":"utf-8"},{"src":"\u002Fueditor\u002Flang\u002Fzh-cn\u002Fzh-cn.js","type":"text\u002Fjavascript","charset":"utf-8"}],"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      errPageReady: false,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        nuxt.errPageReady = false
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_iview_fabcf5d2 === 'function') {
    await nuxt_plugin_iview_fabcf5d2(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_element_f89b5a74 === 'function') {
    await nuxt_plugin_element_f89b5a74(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vextable_3b0d4418 === 'function') {
    await nuxt_plugin_vextable_3b0d4418(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_common_7195563e === 'function') {
    await nuxt_plugin_common_7195563e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_request_281e2659 === 'function') {
    await nuxt_plugin_request_281e2659(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_route_338f5eda === 'function') {
    await nuxt_plugin_route_338f5eda(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueextend_2b93c540 === 'function') {
    await nuxt_plugin_vueextend_2b93c540(app.context, inject)
  }

  if (typeof nuxt_plugin_echarts_6c3fad43 === 'function') {
    await nuxt_plugin_echarts_6c3fad43(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_tim_6e03153e === 'function') {
    await nuxt_plugin_tim_6e03153e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sliderVerify_311cc9a0 === 'function') {
    await nuxt_plugin_sliderVerify_311cc9a0(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
